// Keep this in sync with functions!

export const NotificationType = {
  swapRequested: 'SWAP_REQUESTED',
  swapDeclined: 'SWAP_DECLINED',
  swapAccepted: 'SWAP_ACCEPTED',
  removedFromShift: 'REMOVED_FROM_SHIFT',
  addedToShift: 'ADDED_TO_SHIFT',
  shiftUpdate: 'SHIFT_UPDATE',
  shiftStart: 'SHIFT_START',
  shiftEnd: 'SHIFT_END',
  newSchedulePublished: 'NEW_SCHEDULE_PUBLISHED',
  lateMealBreakEmployeeWarning: 'LATE_MEAL_BREAK_EMPLOYEE_WARNING',
  lateMealBreakManagerWarning: 'LATE_MEAL_BREAK_MANAGER_WARNING',
  missedRestBreakWindowEmployeeWarning: 'MISSED_REST_BREAK_WINDOW_EMPLOYEE_WARNING',
  missedRestBreakWindowManagerWarning: 'MISSED_REST_BREAK_WINDOW_MANAGER_WARNING',
  longBreakEmployeeWarning: 'LONG_BREAK_EMPLOYEE_WARNING',
  longBreakManagerWarning: 'LONG_BREAK_MANAGER_WARNING',
  violationCreated: 'VIOLATION_CREATED',
  violationUpdated: 'VIOLATION_UPDATED',
  breakWaived: 'BREAK_WAIVED',
  clockedIn: 'CLOCKED_IN',
  clockedOut: 'CLOCKED_OUT',
  mealBreakStart: 'MEAL_BREAK_START',
  mealBreakEnd: 'MEAL_BREAK_END',
};

export const USER_NOTIFICATION_SETTINGS = [
  {
    id: NotificationType.swapRequested,
    title: 'Swap requested',
  },
  {
    id: NotificationType.swapAccepted,
    title: 'Swap accepted',
  },
  {
    id: NotificationType.swapDeclined,
    title: 'Swap declined',
  },
  {
    id: NotificationType.removedFromShift,
    title: 'Unassigned shift',
  },
  {
    id: NotificationType.addedToShift,
    title: 'Shift assigned',
  },
  {
    id: NotificationType.shiftUpdate,
    title: 'Shift updated',
  },
  {
    id: NotificationType.shiftStart,
    title: 'Shift to start',
  },
  {
    id: NotificationType.shiftEnd,
    title: 'Shift to end',
  },
  {
    id: NotificationType.newSchedulePublished,
    title: 'New schedule published',
  },
  {
    id: NotificationType.lateMealBreakEmployeeWarning,
    title: 'Late meal break warning',
  },
  {
    id: NotificationType.lateMealBreakManagerWarning,
    title: 'Late meal break manager alert',
  },
  {
    id: NotificationType.longBreakEmployeeWarning,
    title: 'Long break warning',
  },
  {
    id: NotificationType.longBreakManagerWarning,
    title: 'Long break manager alert',
  },
  {
    id: NotificationType.violationCreated,
    title: 'Violation created',
  },
  {
    id: NotificationType.violationUpdated,
    title: 'Violation updated',
  },
  {
    id: NotificationType.breakWaived,
    title: 'Break waived',
  },
  {
    id: NotificationType.clockedIn,
    title: 'Clocked in',
  },
  {
    id: NotificationType.clockedOut,
    title: 'Clocked out',
  },
  {
    id: NotificationType.mealBreakStart,
    title: 'Meal break started',
  },
  {
    id: NotificationType.mealBreakEnd,
    title: 'Meal break ended',
  },
];
